import React, { Component } from "react";
import Search from "../../../../common/components/search-text/search-text";
import Button from "../../../../home/button-classic/button-classic";
import { connect } from "react-redux";
import ACTIONS from "../../../../common/action_constant";
import Delete from "../../../../assets/images/delete.svg";
import Edit from "../../../../assets/images/edit.svg";
import { withRouter } from "react-router-dom";
import { getItemFromSessionStorage } from "Utils/sessionStorage";
import { getEmail, getUserId } from "Utils/common";
import AddActionMaster from "./add-action-master";

class ActionMaster extends Component {
  searchTimeout = null; 
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      offset: 0,
      limit: 10,
      actionConfigurationData: [],
      actionListDropdown: [],
      sapData: [],
      count: 10,
    };
  }
  componentDidMount() {
    this.getActionConfigurationMasterData();
    this.getActionListDropdown();
    this.getSapMasterData();
  }

  getActionConfigurationMasterData = () => {
    const { dispatch, companyId } = this.props;
    const { search, offset, limit } = this.state;
    let param = `?company_id=${companyId}&limit=${limit}&offset=${offset}`;
    if (search) {
      param += `&search=${search}`;
    }
    dispatch({
      type: ACTIONS.PLANTS.GET_ACTION_CONFIGURATION_MASTER,
      param,
      onSuccess: (res) => {
        this.setState({ actionConfigurationData: res && res.ActionList });
      },
    });
  };

  getSapMasterData = (searchText = "") => {
    const { dispatch, companyId } = this.props;
    const { offset, limit } = this.state;

    let param = `?companyId=${companyId}&limit=${limit}&offset=${offset}`;
    if (searchText) param += `&search=${searchText}`;

    dispatch({
      type: ACTIONS.PLANTS.GET_SAP_LIST_MASTER,
      param,
      onSuccess: (res) => {
        this.setState({ sapData: res?.list || [] });
      },
    });
  };

  changeHandler = (value) => {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    this.setState(
      {
        search: value,
        offset: 0,
      },
      () => {
        this.searchTimeout = setTimeout(() => {
          this.getActionConfigurationMasterData();
          this.getSapMasterData();
        }, 500);
      }
    );
  };

  toggleAdd = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen, editData: "" });
  };

  onSaveActionConfigurationMasterData = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.ADD_ACTION_CONFIGURATION_MASTER,
      data,
      onSuccess: () => {
        this.setState(
          { isOpen: false },
          this.getActionConfigurationMasterData()
        );
      },
    });
  };

  getActionListDropdown = () => {
    const { dispatch, companyId } = this.props;
    let param = `?companyId=${companyId}`;
    dispatch({
      type: ACTIONS.PLANTS.GET_ACTION_CONFIGURATION_DROPDOWN,
      param,
      onSuccess: (res) => {
        this.setState({ actionListDropdown: res && res.actions });
      },
    });
  };

  onSearch = () => {
    this.setState({ offset: 0 }, this.getActionConfigurationMasterData);
  };

  onUpdateActionConfigurationMasterData = (data) => {
    const previousData = getItemFromSessionStorage(
      "previousActionConfigurationData"
    );
    previousData["update_flag"] = true;
    previousData["user_email"] = getEmail();
    previousData["user_id"] = getUserId();
    const { dispatch } = this.props;
    const payload = {
      ...data,
      previous_data: previousData,
    };
    dispatch({
      type: ACTIONS.PLANTS.UPDATE_ACTION_CONFIGURATION_MASTER,
      data: payload,
      onSuccess: () => {
        this.setState(
          { isOpen: false, editData: "" },
          this.getActionConfigurationMasterData
        );
      },
    });
  };

  editRawMaterialMaster = (data) => {
    this.setState({
      editData: data,
      isOpen: true,
    });
  };

  deleteRawMaterialMaster = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.DELETE_ACTION_CONFIGURATION_MASTER,
      data: data,
      onSuccess: () => {
        this.getActionConfigurationMasterData();
      },
    });
  };

  previous = () => {
    if (this.state.offset >= this.state.limit) {
      this.setState(
        (prevState) => ({
          offset: prevState.offset - prevState.limit,
        }),
        this.getActionConfigurationMasterData
      );
    }
  };

  next = () => {
    this.setState(
      (prevState) => ({
        offset: prevState.offset + prevState.limit,
      }),
      this.getActionConfigurationMasterData
    );
  };

  clearFilterOnCancel = () => {
    this.setState(
      { search: "", offset: 0 },
      this.getActionConfigurationMasterData
    );
  };

  handleOnClickForAuditBtn = () => {
    const { history, companyId } = this.props;
    const masterType = 59;
    const navUrl = `/auditScreen/${companyId}/${masterType}`;
    history.push(navUrl);
  };

  render() {
    const { actionConfigurationData } = this.state;
    return (
      <div className={"location-network"}>
        <div>
          <div style={{ display: "block", paddingBottom: "15px" }}>
            <Search
              id="search"
              value={this.state.search}
              placeholder="Search..."
              changeHandler={this.changeHandler}
              click={this.onSearch}
              canClear={this.state.search !== ""}
              handleClearFilter={this.clearFilterOnCancel}
            />
            <Button value={"+ Add Action Master"} click={this.toggleAdd} />
            <button
              className="button-classic"
              onClick={this.handleOnClickForAuditBtn}
            >
              Audit
            </button>
          </div>
        </div>
        <table className={"chain-details-section"}>
          <tr className={"list-section header"}>
            <td className={"tabel-header vol-th"}>Action Name </td>
            <td className={"tabel-header vol-th"}>Sap Integration Name </td>
            <td className={"tabel-header vol-th"}>Actions</td>
          </tr>

          {(actionConfigurationData || []).map((action, sIndex) => {
            console.log("action", action);
            return (
              <div className={"list-section content"} key={`route_${sIndex}`}>
                <div className={"tabel-header vol-td"}>
                  {action.action_name}
                </div>
                <div className={"tabel-header vol-td"}>
                  {action.integration_name}
                </div>
                <div className={"tabel-header vol-act"}>
                  <div
                    className={"action-icon"}
                    style={{ backgroundImage: `url(${Edit})` }}
                    onClick={() => this.editRawMaterialMaster(action)}
                  />
                  <div
                    className={"action-icon"}
                    style={{ backgroundImage: `url(${Delete})` }}
                    onClick={() => this.deleteRawMaterialMaster(action)}
                  />
                </div>
              </div>
            );
          })}
        </table>
        <div className="submit-section-pagination">
          <div className="next">
            <Button value="Next" click={this.next} />
          </div>
          <div className="pre">
            <Button value="Previous" click={this.previous} />
          </div>
        </div>
        {this.state.isOpen && (
          <AddActionMaster
            toggleAdd={this.toggleAdd}
            onSave={this.onSaveActionConfigurationMasterData}
            companyId={this.props.companyId}
            editData={this.state.editData}
            onUpdate={this.onUpdateActionConfigurationMasterData}
            sapListData={this.state.sapData}
            actionlistDropdown={this.state.actionListDropdown}
            actionData={this.state.actionConfigurationData}
            dispatch={this.props.dispatch}
             fetchSapList={this.getSapMasterData}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zones: state.plantsDepots.zones,
    countryListData: state.master.countryList,
    productList: state.master.itemList,
    routeCodeList: state.home.routeCodes || [],
  };
};

export default connect(mapStateToProps)(withRouter(ActionMaster));
